import React, { useContext, useEffect, useState } from "react";
import {
  AlertTriangle,
  Plus,
  MessageSquare,
  Search,
  Eye,
  CheckSquare,
  ArrowRight,
  X,
  Send,
} from "lucide-react";
import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
import "../../../assets/styles/distributor/DistributorDisputeSupport.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";

/* =============================================
   MOCK DATA
   ============================================= */
const INITIAL_DISPUTES = [
  {
    id: "D-001",
    party: "Ali Ahmed",
    source: "Customer",
    issue: "Short delivery — received 1.5L instead of 2L",
    date: "Mar 15, 2024",
    priority: "high",
    status: "open",
  },
  {
    id: "D-002",
    party: "Sara Khan",
    source: "Customer",
    issue: "Late delivery — milk arrived at 9 AM",
    date: "Mar 14, 2024",
    priority: "medium",
    status: "inprogress",
  },
  {
    id: "D-003",
    party: "Farmer Abdul",
    source: "Distributor",
    issue: "Received less quantity than agreed",
    date: "Mar 13, 2024",
    priority: "high",
    status: "open",
  },
  {
    id: "D-004",
    party: "Fatima Noor",
    source: "Customer",
    issue: "Quality complaint — milk was watery",
    date: "Mar 12, 2024",
    priority: "high",
    status: "resolved",
  },
];

const INITIAL_TICKETS = [
  {
    id: "T-001",
    subject: "Payment gateway not working",
    date: "Mar 15, 2024",
    priority: "high",
    status: "open",
  },
  {
    id: "T-002",
    subject: "Need help with area setup",
    date: "Mar 13, 2024",
    priority: "low",
    status: "resolved",
  },
];

const SUPPLIERS = ["Farmer Abdul", "Green Valley Dairy", "Punjab Milk Farm"];

/* =============================================
   PRIORITY & STATUS BADGE HELPERS
   ============================================= */
// const PriorityBadge = ({ priority }) => (
//   <span className={`distDispute-priority distDispute-priority-${priority}`}>
//     {priority() + priority.slice(1)}
//   </span>
// );

const StatusBadge = ({ status }) => {
  const map = {
    open: { cls: "distDispute-status-open", label: "open" },
    inprogress: { cls: "distDispute-status-inprogress", label: "in Progress" },
    resolved: { cls: "distDispute-status-resolved", label: "resolved" },
  };
  // const { cls, label } = map[status] || map.open;
  const { cls, label } = map[status];
  return <span className={`distDispute-status ${cls}`}>{label}</span>;
};

/* =============================================
   GENERATE DISPUTE MODAL
   ============================================= */
const GenerateDisputeModal = ({ onClose, onSubmit }) => {
  const [form, setForm] = useState({
    supplier: "",
    description: "",
    priority: "Medium",
  });
  const handle = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  return (
    <div className="distDispute-overlay" onClick={onClose}>
      <div className="distDispute-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distDispute-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distDispute-modal-header">
          <h4>Generate Dispute Against</h4>
          <p>Report an issue with a supplier's delivery</p>
        </div>

        <div className="distDispute-form-field">
          <label>Supplier</label>
          <select
            className="distDispute-form-select"
            name="supplier"
            value={form.supplier}
            onChange={handle}
          >
            <option value="">Select supplier</option>
            {SUPPLIERS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div className="distDispute-form-field">
          <label>Issue Description</label>
          <textarea
            className="distDispute-form-textarea"
            name="description"
            placeholder="Describe the issue..."
            value={form.description}
            onChange={handle}
          />
        </div>

        {/* <div className="distDispute-form-field">
          <label>Priority</label>
          <select className="distDispute-form-select" name="priority" value={form.priority} onChange={handle}>
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
          </select>
        </div> */}

        <div className="distDispute-modal-footer">
          <button className="distDispute-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="distDispute-btn-red"
            onClick={() => {
              onSubmit(form);
              onClose();
            }}
          >
            Submit Dispute
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   CREATE SUPPORT TICKET MODAL
   ============================================= */
// const CreateTicketModal = ({ onClose, onSubmit }) => {
//   const [form, setForm] = useState({ subject: "", description: "", priority: "Medium" });
//   const handle = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   return (
//     <div className="distDispute-overlay" onClick={onClose}>
//       <div className="distDispute-modal" onClick={(e) => e.stopPropagation()}>
//         <button className="distDispute-modal-close" onClick={onClose}><X size={18}/></button>
//         <div className="distDispute-modal-header">
//           <h4>Create Support Ticket</h4>
//           <p>Submit a new support request to admin</p>
//         </div>

//         <div className="distDispute-form-field">
//           <label>Subject</label>
//           <input
//             className="distDispute-form-input"
//             name="subject"
//             placeholder="Brief description"
//             value={form.subject}
//             onChange={handle}
//           />
//         </div>

//         <div className="distDispute-form-field">
//           <label>Description</label>
//           <textarea
//             className="distDispute-form-textarea"
//             name="description"
//             placeholder="Detailed description..."
//             value={form.description}
//             onChange={handle}
//           />
//         </div>

//         <div className="distDispute-form-field">
//           <label>Priority</label>
//           <select className="distDispute-form-select" name="priority" value={form.priority} onChange={handle}>
//             <option>Low</option>
//             <option>Medium</option>
//             <option>High</option>
//           </select>
//         </div>

//         <div className="distDispute-modal-footer">
//           <button className="distDispute-btn-cancel" onClick={onClose}>Cancel</button>
//           <button className="distDispute-btn-green" onClick={() => { onSubmit(form); onClose(); }}>
//             Submit Ticket
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

/* =============================================
   VIEW DISPUTE DETAIL MODAL
   ============================================= */
const ViewDisputeModal = ({ dispute, onClose, onResolve }) => {
  const [message, setMessage] = useState("");
  const [msgs, setMsgs] = useState([]);
  // const [msgs, setMsgs] = useState([
  //   {
  //     system: true,
  //     text: `Dispute ${dispute.id} opened regarding: ${dispute.issue}`,
  //     time: "10:00 AM",
  //   },
  //   {
  //     system: false,
  //     sender: dispute.party,
  //     text: dispute.issue,
  //     time: "10:01 AM",
  //   },
  // ]);
  const { baseUrl } = useContext(AppContext);

  const send = () => {
    const formData = new FormData();
    formData.append("mwhelpsupport_id", dispute.id);
    formData.append("message", message);

    axios
      .post(`${baseUrl}/distributor/chat/sendMessage`, formData, {
        headers: { "Content-Type": "multipart/formdata" },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          loadMessages();
          setMessage("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // if (!message.trim()) return;
    // setMsgs((p) => [
    //   ...p,
    //   { system: false, sender: "You", text: message, time: "Now" },
    // ]);
    // setMessage("");
  };

  const loadMessages = () => {
    const formData = new FormData();
    formData.append("mwhelpsupport_id", dispute.id);

    axios
      .post(`${baseUrl}/distributor/chat/getMessages`, formData, {
        headers: { "Content-type": "multipart/formdata" },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setMsgs(res.data.messages);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("log from chat", dispute);
    loadMessages();
  }, []);

  return (
    <div className="distDispute-overlay" onClick={onClose}>
      <div
        className="distDispute-modal"
        style={{ maxWidth: 460 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="distDispute-modal-close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="distDispute-modal-header">
          <h4>{dispute.id} — Dispute Details</h4>
        </div>

        {/* Info grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px 20px",
            marginBottom: 14,
            fontSize: "0.85rem",
          }}
        >
          {/* <div>
            <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>
              Party:
            </div>
            <strong>{dispute.party}</strong>
          </div>
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>
              Source:
            </div>
            <strong>{dispute.source}</strong>
          </div> */}
          {/* <div>
            <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>
              Priority:
            </div>
            <PriorityBadge priority={dispute.priority} />
          </div> */}
          <div>
            <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>
              Status:
            </div>
            <StatusBadge status={dispute.status} />
          </div>
          <div style={{ gridColumn: "1/-1" }}>
            <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>
              Issue:
            </div>
            <strong style={{ fontSize: "0.875rem" }}>{dispute.subject}</strong>
          </div>
        </div>

        {/* Discussion */}
        {dispute.status == "open" && (
          <>
            <div className="distDispute-discussion">
              <div className="distDispute-discussion-title">Discussion</div>
              <div className="distDispute-discussion-scroll">
                {msgs.map((m, i) => (
                  <div
                    key={i}
                    className="distDispute-msg"
                    style={{
                      textAlign: m.sender == "support" ? "right" : "left",
                    }}
                  >
                    {!m.system && (
                      <div className="distDispute-msg-sender">{m.sender}</div>
                    )}
                    <div>{m.message}</div>
                    <div className="distDispute-msg-time">{m.time}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Message input */}
            <div className="distDispute-msg-input-row">
              <input
                className="distDispute-form-input"
                style={{ flex: 1, margin: 0 }}
                placeholder="Type a message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && send()}
              />
              <button className="distDispute-send-btn" onClick={send}>
                <Send size={15} style={{ stroke: "#fff" }} />
              </button>
            </div>

            {/* Footer actions */}
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                marginBottom: 10,
              }}
            >
              <button
                className="distDispute-btn-green"
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                }}
                onClick={() => {
                  onResolve(dispute.id);
                  onClose();
                }}
              >
                <CheckSquare size={14} /> Mark as Resolved
              </button>
              {/* <button
            className="distDispute-btn-outline"
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            <ArrowRight size={14} /> Forward to Admin
          </button> */}
            </div>
          </>
        )}
        <div style={{ textAlign: "right" }}>
          <button className="distDispute-btn-cancel" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
   VIEW TICKET DETAIL MODAL
   ============================================= */
// const ViewTicketModal = ({ ticket, onClose }) => {
//   const [message, setMessage] = useState("");
//   const [msgs, setMsgs] = useState([
//     { system: true, text: `Support ticket ${ticket.id} opened: ${ticket.subject}`, time: "10:00 AM" },
//   ]);

//   const send = () => {
//     if (!message.trim()) return;
//     setMsgs((p) => [...p, { system: false, sender: "You", text: message, time: "Now" }]);
//     setMessage("");
//   };

//   return (
//     <div className="distDispute-overlay" onClick={onClose}>
//       <div className="distDispute-modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
//         <button className="distDispute-modal-close" onClick={onClose}><X size={18}/></button>
//         <div className="distDispute-modal-header">
//           <h4>{ticket.id} — Support Ticket</h4>
//         </div>

//         {/* Info */}
//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 20px", marginBottom: 14, fontSize: "0.85rem" }}>
//           <div>
//             <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>Subject:</div>
//             <strong>{ticket.subject}</strong>
//           </div>
//           <div>
//             <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>Date:</div>
//             <strong>{ticket.date}</strong>
//           </div>
//           <div>
//             <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>Priority:</div>
//             <PriorityBadge priority={ticket.priority} />
//           </div>
//           <div>
//             <div style={{ opacity: 0.5, fontSize: "0.73rem", marginBottom: 2 }}>Status:</div>
//             <StatusBadge status={ticket.status} />
//           </div>
//         </div>

//         {/* Conversation */}
//         <div className="distDispute-discussion">
//           <div className="distDispute-discussion-title">Conversation with Admin</div>
//           <div className="distDispute-discussion-scroll">
//             {msgs.map((m, i) => (
//               <div key={i} className="distDispute-msg" style={{ textAlign: "center" }}>
//                 <div>{m.text}</div>
//                 <div className="distDispute-msg-time">{m.time}</div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Message input */}
//         <div className="distDispute-msg-input-row">
//           <input
//             className="distDispute-form-input"
//             style={{ flex: 1, margin: 0 }}
//             placeholder="Type a message..."
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && send()}
//           />
//           <button className="distDispute-send-btn" onClick={send}>
//             <Send size={15} style={{ stroke: "#fff" }} />
//           </button>
//         </div>

//         <div style={{ textAlign: "right" }}>
//           <button className="distDispute-btn-cancel" onClick={onClose}>Close</button>
//         </div>
//       </div>
//     </div>
//   );
// };

/* =============================================
   MAIN PAGE CONTENT
   ============================================= */
const DisputeSupportContent = () => {
  const [activeTab, setActiveTab] = useState("disputes");
  const [disputes, setDisputes] = useState("");
  const [tickets, setTickets] = useState(INITIAL_TICKETS);
  const [search, setSearch] = useState("");
  const [showGenDispute, setShowGenDispute] = useState(false);
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  const [viewDispute, setViewDispute] = useState(null);
  const [viewTicket, setViewTicket] = useState(null);
  const [distributorDisputes, setDistributorDisputes] = useState([]);
  const { loggedInDistributor, baseUrl } = useContext(AppContext);

  /* Handlers */
  const handleAddDispute = (form) => {
    setDisputes((prev) => [
      {
        id: `D-00${prev.length + 1}`,
        // party: form.supplier,
        // source: "Distributor",
        issue: form.description,
        date: new Date().toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        }),
        priority: form.priority.toLowerCase(),
        status: "open",
      },
      ...prev,
    ]);
  };

  const handleAddTicket = (form) => {
    setTickets((prev) => [
      {
        id: `T-00${prev.length + 1}`,
        subject: form.subject,
        date: new Date().toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        }),
        priority: form.priority.toLowerCase(),
        status: "open",
      },
      ...prev,
    ]);
  };

  const handleResolveDispute = (id) => {
    // setDisputes((prev) =>
    //   prev.map((d) => (d.id === id ? { ...d, status: "resolved" } : d)),
    // );

    console.log("dispute ki id", id);
    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${baseUrl}/distributor/dispute/changeDisputeStatus`, formData, {
        header: { "Content-type": "multipart-formdata" },
      })
      .then((res) => {
        console.log(res.data);
        viewAllDisputes();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /* Filtered */
  // const filteredDisputes = disputes.filter((d) =>
  //   d.party.toLowerCase().includes(search.toLowerCase()) ||
  //   d.issue.toLowerCase().includes(search.toLowerCase())
  // );

  const filteredTickets = tickets.filter((t) =>
    t.subject.toLowerCase().includes(search.toLowerCase()),
  );

  const viewAllDisputes = () => {
    const formData = new FormData();
    formData.append("mwdistributor_id", loggedInDistributor.id);

    axios
      .post(`${baseUrl}/distributor/dispute/viewAllDisputes`, formData, {
        header: { "Content-type": "multipart-formdata" },
      })
      .then((res) => {
        console.log(res.data);
        setDistributorDisputes(res.data.disputes);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    viewAllDisputes();
  }, []);

  return (
    <div className="distDispute-page">
      {/* Header */}
      <div className="distDispute-header-row">
        <div className="distDispute-title">
          <h2>Disputes</h2>
          <p>Manage disputes with Customer</p>
        </div>
        <div className="distDispute-header-btns">
          {/* <button className="distDispute-btn-generate" onClick={() => setShowGenDispute(true)}>
            <AlertTriangle size={15}/> Generate Dispute
          </button> */}
          {/* <button className="distDispute-btn-ticket" onClick={() => setShowCreateTicket(true)}>
            <Plus size={15}/> Support Ticket
          </button> */}
        </div>
      </div>

      {/* Tabs */}
      <div className="distDispute-tabs">
        {/* <button
          className={`distDispute-tab-btn ${activeTab === "disputes" ? "active" : ""}`}
          onClick={() => { setActiveTab("disputes"); setSearch(""); }}
        >
          <AlertTriangle size={14}/> Disputes
        </button> */}
        {/* <button
          className={`distDispute-tab-btn ${activeTab === "tickets" ? "active" : ""}`}
          onClick={() => { setActiveTab("tickets"); setSearch(""); }}
        >
          <MessageSquare size={14}/> Support Tickets
        </button> */}
      </div>

      {/* Search */}
      <div className="distDispute-search-wrap">
        <Search size={16} />
        <input
          className="distDispute-search-input"
          placeholder={
            activeTab === "disputes"
              ? "Search disputes..."
              : "Search tickets..."
          }
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="distDispute-table-card">
        <div className="distDispute-table-wrap">
          {/* DISPUTES TABLE */}
          {activeTab === "disputes" && (
            <table className="distDispute-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer</th>
                  {/* <th>Source</th> */}
                  <th>Issue</th>
                  <th>Date</th>
                  {/* <th>Priority</th> */}
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {distributorDisputes?.map((d) => {
                  return (
                    <tr key={d.id}>
                      <td>
                        <span className="distDispute-id">{d.id}</span>
                      </td>
                      <td>
                        <strong style={{ fontWeight: 600 }}>
                          {d.mwcustomer?.fullName}
                        </strong>
                      </td>
                      {/* <td>
                      {d.source === "Customer" ? (
                        <span className="distDispute-source-customer">
                          {d.source}
                        </span>
                      ) : (
                        <span className="distDispute-source-distributor">
                          {d.source}
                        </span>
                      )}
                    </td> */}
                      <td style={{ maxWidth: 240, fontSize: "0.82rem" }}>
                        {d.subject}
                      </td>
                      <td style={{ fontSize: "0.82rem", opacity: 0.7 }}>
                        {d.created_at}
                      </td>
                      {/* <td>
                      <PriorityBadge priority={d.priority} />
                    </td> */}
                      <td>
                        {/* <StatusBadge status={d.status} /> */}
                        <span
                          className={`distDispute-status distDispute-status-${d.status}`}
                        >
                          {d.status}
                        </span>
                      </td>
                      <td>
                        <div className="distDispute-table-actions">
                          {/* Eye icon */}
                          <button
                            className="distDispute-view-icon-btn"
                            title="View"
                            onClick={() => setViewDispute(d)}
                          >
                            <Eye size={16} />
                          </button>

                          {d.status !== "resolved" && (
                            <>
                              <button
                                className="distDispute-action-resolve"
                                onClick={() => handleResolveDispute(d.id)}
                              >
                                <CheckSquare size={13} /> Resolve
                              </button>
                              {/* <button className="distDispute-action-forward">
                              <ArrowRight size={13} /> Forward to Admin
                            </button> */}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {/* SUPPORT TICKETS TABLE */}
          {/* {activeTab === "tickets" && (
            <table className="distDispute-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Subject</th>
                  <th>Date</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTickets.map((t) => (
                  <tr key={t.id}>
                    <td><span className="distDispute-id">{t.id}</span></td>
                    <td><strong style={{ fontWeight: 600 }}>{t.subject}</strong></td>
                    <td style={{ fontSize: "0.82rem", opacity: 0.7 }}>{t.date}</td>
                    <td><PriorityBadge priority={t.priority}/></td>
                    <td><StatusBadge status={t.status}/></td>
                    <td>
                      <button
                        className="distDispute-view-icon-btn"
                        title="View"
                        onClick={() => setViewTicket(t)}
                      >
                        <Eye size={16}/>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )} */}
        </div>
      </div>

      {/* Modals */}
      {showGenDispute && (
        <GenerateDisputeModal
          onClose={() => setShowGenDispute(false)}
          onSubmit={handleAddDispute}
        />
      )}
      {/* {showCreateTicket && <CreateTicketModal    onClose={() => setShowCreateTicket(false)} onSubmit={handleAddTicket} />} */}
      {viewDispute && (
        <ViewDisputeModal
          dispute={viewDispute}
          onClose={() => setViewDispute(null)}
          onResolve={handleResolveDispute}
        />
      )}
      {/* {viewTicket       && <ViewTicketModal      ticket={viewTicket}  onClose={() => setViewTicket(null)} />} */}
    </div>
  );
};

/* =============================================
   EXPORT — wrapped in DistributorMasterLayout
   ============================================= */
const DistributorDisputeSupport = () => (
  <DistributorMasterLayout>
    <DisputeSupportContent />
  </DistributorMasterLayout>
);

export default DistributorDisputeSupport;
